import {Dispatch, FC, SetStateAction} from 'react'
import {Modal} from 'react-bootstrap'
// import { useCentral } from '../../../../../../../hooks/useCentral'
import {KTSVG} from '../../../../../../_metronic/helpers'
// import { KTableLoading } from '../../../../../../../components/UI'
type ModalSize = 'xl' | 'md' | 'sm' | 'lg'

interface Props {
  show: boolean
  size?: ModalSize
  setShow: Dispatch<SetStateAction<boolean>>
  children: React.ReactNode
  title?: string
  type?: string
  variant?: string
  showFooter?: boolean
}

const ModalComponent: FC<Props> = ({
  show,
  setShow,
  children,
  title,
  type,
  variant = 'default',
  size = 'md',
  showFooter = true,
}) => {
  // const [loading, setLoading] = useState(false)

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName={`modal-${size}`}
      aria-hidden='true'
      onHide={() => setShow(false)}
    >
      <div className='modal-content'>
        <div className={'modal-header py-2 sdx-modal-' + variant}>
          {type === 'Alert' && (
            <div className='sdx-modal-title'>
              {' '}
              <p>Error!</p>
            </div>
          )}
          {type === 'modal' && <h5 className='mb-0'>{title}</h5>}

          <div
            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
            onClick={() => setShow(false)}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body py-2'>
          {children}

          {/* {loading ? <KTableLoading title='Cargando...' /> : null} */}
        </div>
        {showFooter && (
          <div className='modal-footer py-2'>
            <div className='d-flex justify-content-center mb-3'>
              <button
                type='button'
                className='btn btn-light-primary me-5'
                onClick={() => setShow(false)}
              >
                Cancelar
              </button>
              {type !== 'Alerta' && variant !== 'error' && (
                <button type='button' className='btn btn-primary'>
                  Guardar
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </Modal>
  )
}

export {ModalComponent}
